import notEmpty from '../../core/util/notEmpty';

export const findBySku = <T extends { sku: string }>(
    items: T[],
    sku: string
) => {
    return items.filter(notEmpty).find(item => item.sku === sku);
};
